import { FC } from 'react'
import { Form, Tab, Tabs } from 'react-bootstrap'
import { Editor } from 'primereact/editor'
import { useAppSelector } from '../../../../store/hooks'
import { Language } from '../../../../features/security/security.slice'
import { SectionValueTranslatedFieldProps } from './PageBuilder.d'

const SectionValueTranslatedField: FC<SectionValueTranslatedFieldProps> = ({
    id,
    label = '',
    showLabel = true,
    page_content_id,
    name,
    formikProps,
    groupClassName = '',
    readonly = false,
    tabGroupClassName,
    tabContentClassName,
}) => {
    const initData = useAppSelector((state: any) => state.security.initData)

    const { values, setFieldValue } = formikProps

    return (
        <div className={groupClassName ? ' ' + groupClassName : ''}>
            <Tabs
                id={id + '_RenderTranslatedFieldsTabs'}
                className={`mb-0 ${tabGroupClassName ? tabGroupClassName : ''}`}
            >
                {Object.keys(initData.languages.data).map((locale) => {
                    const lang: Language = initData.languages.data[locale]

                    const valueProp = `pillars[${page_content_id}][${name}][_${lang.id}]`

                    return (
                        <Tab
                            eventKey={locale}
                            title={lang.name}
                            key={locale}
                            className={`fade border-start border-end border-bottom mb-3 p-2 in-tab-content ${
                                tabContentClassName ? tabContentClassName : ''
                            }`}
                        >
                            <>
                                {showLabel === false ? null : (
                                    <Form.Label>{label}</Form.Label>
                                )}
                                {/** Change this to CKEditor */}
                                <Editor
                                    style={{
                                        minHeight: '200px',
                                    }}
                                    className="mb-3"
                                    value={
                                        values.pillars[page_content_id]?.[name][
                                            '_' + lang.id
                                        ] || ''
                                    }
                                    onTextChange={(e) =>
                                        setFieldValue(valueProp, e.htmlValue)
                                    }
                                    readOnly={readonly}
                                />
                            </>
                        </Tab>
                    )
                })}
            </Tabs>
        </div>
    )
}

export default SectionValueTranslatedField
